import React from "react";
import { createRoot } from "react-dom/client";
import NRRCalculator from "./pages/NRRCalculator";


// Render your React component instead
//const root = createRoot(document.getElementById("app"));
//root.render(<h1>Hello, worasdfld</h1>);

const domRoot = document.getElementById("app");
if (domRoot) {
  const nrrRoot = createRoot(domRoot);
  nrrRoot.render(<NRRCalculator />);
}